export class ChatbotSessionRequestFailure extends Error {
  constructor(msg: string, method = 'unknown method') {
    super(`Get chatbot session request failed [${method}]: ${msg}`);

    Object.setPrototypeOf(this, ChatbotSessionRequestFailure.prototype);
  }
}
